import {
  CardToSyncByUserIdRequestType,
  CardToSyncByUserIdResponseType,
  CardToSyncStatusEnum,
} from "magic-shared-types";
import { api } from "../api";
import { BASE_SERVER_PATH } from "../../constant";

export const myServerApis = api.injectEndpoints({
  endpoints: (builder) => ({
    getCardToSyncByUser: builder.query<
      CardToSyncByUserIdResponseType,
      CardToSyncByUserIdRequestType
    >({
      query: ({ page, pageSize, status, source, game_id, name }) => ({
        url: `${BASE_SERVER_PATH}/api/card-to-sync/user`,
        method: "GET",
        params: { page, pageSize, status, source, game_id, name },
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    updateSyncStatus: builder.mutation<
      { success: true },
      {
        status: CardToSyncStatusEnum;
        syncId: number;
      }
    >({
      query: ({ status, syncId }) => ({
        url: `${BASE_SERVER_PATH}/api/card-to-sync/${syncId}/change-cm-ct-status`,
        method: "POST",
        body: { status },
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
  }),
});

export const { useGetCardToSyncByUserQuery, useUpdateSyncStatusMutation } =
  myServerApis;
